import { useEffect } from "react";

/**
 * Lightweight head manager — avoids adding react-helmet-async as a dependency.
 * Sets document.title + the handful of meta/link tags we care about per page.
 * Falls back to the defaults in public/index.html when the component unmounts
 * (we restore to a single consistent "home" state so cross-navigation doesn't
 * leave stale per-page OG tags on another page).
 */
const DEFAULTS = {
  title: "anArtizen — Unfair Advantage",
  description:
    "anArtizen — The operating system for India's creative economy. Community. Marketplace. Institution.",
  image: "https://anartizen.com/ua-hero-grid.png",
  url: "https://anartizen.com",
  type: "website",
};

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo({
  title,
  description,
  image,
  url,
  type = "website",
  canonical,
}) {
  useEffect(() => {
    const t = title ? `${title} · anArtizen` : DEFAULTS.title;
    const d = description || DEFAULTS.description;
    const img = image || DEFAULTS.image;
    const u = url || canonical || (typeof window !== "undefined" ? window.location.origin + window.location.pathname : DEFAULTS.url);

    document.title = t;
    setMeta("description", d);
    // Open Graph
    setMeta("og:title", t, "property");
    setMeta("og:description", d, "property");
    setMeta("og:image", img, "property");
    setMeta("og:url", u, "property");
    setMeta("og:type", type, "property");
    setMeta("og:site_name", "anArtizen", "property");
    // Twitter
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", t);
    setMeta("twitter:description", d);
    setMeta("twitter:image", img);
    // Canonical
    setLink("canonical", canonical || u);
  }, [title, description, image, url, type, canonical]);

  return null;
}
